module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    on: {
      "click": _vm.baixarCsv
    }
  }, [_vm._v("Exportar CSV")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e374e80"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/VAChartCsv.vue
// module id = 667
// module chunks = 1